function inRange(value, max, min) {
  return value <= max && value >= min;
}

export function getPlantLightingMode(angle) {
  // JUST make it 0–360 (no flipping)
  const a = (angle + 360) % 360;

  // SUNRISE
  if (
    inRange(a, 10, 0) ||
    inRange(a, 359, 350) ||
    inRange(a, 190, 170)
  ) {
    return "sunrise";
  }

  // DAY
  if (
    inRange(a, 349, 271) ||
    inRange(a, 169, 101)
  ) {
    return "day";
  }

  // SUNSET
  if (
    inRange(a, 270, 250) ||
    inRange(a, 100, 80)
  ) {
    return "sunset";
  }

  // NIGHT
  if (
    inRange(a, 249, 191) ||
    inRange(a, 79, 11)
  ) {
    return "night";
  }

  return "day";
}